export const getTimestamp = (create: Date, now: Date) => {  
  if(create && now) {
    //TODO: Посмотреть, можно ли упростить получение ютс стемпа, через toUTCString не работает
    const nowUTC = new Date(
      now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 
      now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds()
    );
    
    const nowStamp = nowUTC.getTime();
    const createTimeStamp = create.getTime();

    let diff = (nowStamp - createTimeStamp) / 1000 //разница в секундах;
    if (diff / 60 < 1) 
      return `${Math.ceil(diff)} сек. назад`;
    diff /= 60;  //разница в минутах
    if (diff / 60 < 1) 
      return `${Math.ceil(diff)} мин. назад`;
    diff /= 60;  //разница в часах
    if (diff / 24 < 1) 
      return `${Math.ceil(diff)} ч. назад`;
    diff /= 24;  //разница в днях
    return `${Math.ceil(diff)} д. назад`;
  }
}
